import styles from './Skeleton.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'clsx';

function SkeletonText(_ref) {
  let {
    variant = 'body',
    length = '100%',
    lines = 1,
    className: callerClassName,
    tag
  } = _ref;
  const className = classNames('dsx-component', callerClassName);
  const numericLength = parseFloat(length);
  const lengthType = length.replace(numericLength.toString(), '');
  return /*#__PURE__*/jsx("div", {
    className: className,
    "data-dsx--skeleton-text": tag,
    children: [...new Array(lines)].map((_, index) => {
      const lineClassName = classNames(styles['skeleton'], styles['skeleton-text']);
      const width = lines > 1 && lines - 1 === index ?
      // Make last line a bit shorter to make it look like a paragraph
      `${numericLength * 0.85}${lengthType}` : length;
      return /*#__PURE__*/jsx("div", {
        className: styles[variant],
        children: /*#__PURE__*/jsx("div", {
          style: {
            width
          },
          className: lineClassName
        })
      }, index);
    })
  });
}

export { SkeletonText };
